import React from 'react';
import { useContent } from '../../hooks/useContent';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const FooterSection = () => {
    const { content, isLoading, isError, error, loadContentBySection } = useContent('footer');

    // Get the footer content data
    const footerData = content.length > 0 ? content[0].content_data : null;

    if (isLoading) {
        return (
            <footer className="section inner-footer bg-gray ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <LoadingSpinner size="lg" />
                        </div>
                    </div>
                </div>
            </footer>
        );
    }

    if (isError) {
        return (
            <footer className="section inner-footer bg-gray ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <ErrorMessage error={error} onRetry={() => loadContentBySection('footer')} />
                        </div>
                    </div>
                </div>
            </footer>
        );
    }

    if (!footerData) {
        return (
            <footer className="section inner-footer bg-gray ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="text-center">
                                <p>No footer content available.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }

    // Combine all footer links for the simplified footer
    const allFooterLinks = [
        ...(footerData.footerLinks?.company || []),
        ...(footerData.footerLinks?.product || []),
        ...(footerData.footerLinks?.support || [])
    ];

    return (
        <footer className="section inner-footer bg-gray ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-6">
                        {/* Footer Items */}
                        <div className="footer-items text-center">
                            {/* Logo */}
                            <a className="navbar-brand" href="/#">
                                <img className="logo" src={footerData.logo} alt="SalesPinch" />
                            </a>
                            <p className="mt-2 mb-3">{footerData.description}</p>
                            <ul className="d-flex flex-column flex-sm-row justify-content-between">
                                {allFooterLinks.map((item, idx) => (
                                    <li key={`fl_${idx}`} className="py-2">
                                        <a href={item.link}>{item.name}</a>
                                    </li>
                                ))}
                            </ul>
                            {/* Copyright Area */}
                            <div className="copyright-area border-0 pt-3">
                                <p>{footerData.copyright} | Made with <i className="fas fa-heart" /> By <a target="_blank" rel="noopener noreferrer" href="https://themeforest.net/user/theme_land">Themeland</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default FooterSection;